import { PCWPortfolioCreateRequest, PortfolioItemExtended, PortfolioItemTreeNode } from 'types/portfolios';
import { isPortfolioItemExtended } from 'utils/portfolio';
import { PCW_STEPS } from './constants';
import { PortfolioBasicsFormData } from './steps/PortfolioBasicsStep';
import { PcwGeneralAddItemStep } from './types';
import axios from 'axios';

export const getSelectedNodesWithTypeId = (
    nodes: PortfolioItemTreeNode[],
    typeIds: number[]
): PortfolioItemExtended[] => {
    if (!nodes || !Array.isArray(nodes)) {
        return [];
    }
    return nodes.flatMap((node) =>
        node.nodes
            .filter((child) => child.isSelected)
            .filter((child) => !!child?.properties?.typeId && typeIds.includes(child.properties.typeId))
            .map((child) => child.properties)
            .filter(isPortfolioItemExtended)
    );
};

export const createPortfolioPayload = (formData: any, metadata: any): PCWPortfolioCreateRequest => {
    const basicsStep = formData?.[PCW_STEPS.PCW_PORTFOLIO_BASICS_STEP_ID] as PortfolioBasicsFormData;

    const mainMarketModelId = basicsStep.mainMarketModel;

    // Setting locationId to 1 for now until something else is needed
    const locationId = 1;

    const steps = [
        formData?.[PCW_STEPS.PCW_FORWARD_CURVES_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_FORWARD_CURVES_CONSTRAINTS_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_ADD_ASSETS_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_ANCILLARIES_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_GLOBAL_SHAPES_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_HEDGES_CONTRACTS_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_HYDRO_STEP_ID] as PcwGeneralAddItemStep,
        formData?.[PCW_STEPS.PCW_LOAD_STEP_ID] as PcwGeneralAddItemStep,
    ];

    const ids = steps
        .filter((step) => step?.selected && Array.isArray(step.selected))
        .flatMap((step) => step.selected?.map((item) => item.id) || [])
        .filter((id) => id !== undefined && id !== null);

    ids.push(Number(mainMarketModelId));

    const payload: PCWPortfolioCreateRequest = {
        portfolioBasicInfo: {
            parentId: Number(metadata?.parentPortfolio?.properties?.id),
            bookId: Number(basicsStep.bookId),
            name: basicsStep.portfolioName,
            description: basicsStep.description,
            securityId: Boolean(basicsStep.isMaster),
            locationId: locationId,
            portfolioTypeId: 1,
            dispatchTypeId: 1,
            properties: [],
        },
        itemIds: ids,
    };
    return payload;
};

export const submitPortfolioWizard = async (payload: PCWPortfolioCreateRequest): Promise<number> => {
    const result = await axios.post<number>('/portfolios/create-portfolio-assign-items', payload);
    return result.data;
};
